import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BannerType } from '../../../environments/common';

@Component({
  selector: 'card-grid',
  templateUrl: './card-grid.component.html',
  styleUrls: ['./card-grid.component.scss']
})
export class CardGridComponent  implements OnInit, AfterViewChecked {
  
  @Input() items: any[];
  @Input() show: boolean;
  @Input() banner: BannerType;
  @Input() page: number;

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  position: number = 4;
  size: number = 17;

  bannerPosition: boolean[];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.updateBanner();
  }

  ngAfterViewChecked() {
    this.updateBanner();
    this.cdr.detectChanges(); // Marca el componente para la detección de cambios
  }

  updateBanner(){
    this.bannerPosition = Array(this.items.length).fill(false);

    for (let i = this.position; i < this.items.length; i += this.size) {
      this.bannerPosition[i] = true;
    }
    if(this.bannerPosition.length <= this.position){
      this.bannerPosition[this.bannerPosition.length-1] = true;
    }
  }

}
